import { WithRestaurantIdEndpoint } from "./WithRestaurantIdEndpoint";

export class DailyAvailabilitiesEndpoint extends WithRestaurantIdEndpoint {
  constructor() {
    super("daily_availabilities");
  }
}
